/* Expand/collapse for the allergen and nutrition accordions (Borough 22).
 * Delegated to the document so it survives the per-variant innerHTML swaps done
 * by b22-variant-panels.js. It replaces the inline DOMContentLoaded handler that
 * used to live in allergen-information.liquid, which bound to nodes that are now
 * replaced on variant change and would have been bound twice per swap.
 */
document.addEventListener('click', function (event) {
  var header = event.target.closest('.allergen-content .donut-header');
  if (!header) return;
  var item = header.closest('.donut-item');
  if (item) item.classList.toggle('expanded');
});
